import { render, staticRenderFns } from "./trainingtable.vue?vue&type=template&id=4074a7b7&scoped=true"
import script from "./trainingtable.vue?vue&type=script&lang=js"
export * from "./trainingtable.vue?vue&type=script&lang=js"
import style0 from "./trainingtable.vue?vue&type=style&index=0&id=4074a7b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074a7b7",
  null
  
)

export default component.exports